module.exports = __webpack_public_path__ + "img/case_item_bg.d451df7b.svg";